import { AuroraBackground } from "@/components/aceternity/aurora-background";
import { Spotlight } from "@/components/aceternity/spotlight";
import { GridPattern } from "@/components/aceternity/grid-pattern";
import { cn } from "@/lib/utils";

/**
 * Composite background for app surfaces. Layers:
 *   1. Aurora beams (deepest, slow drift)
 *   2. Dot-grid pattern with radial fade-out at the edges
 *   3. Cursor-following spotlight (top layer)
 *
 * Render INSIDE a relative parent. Fixed-positioned so it stays
 * behind every scrolled section.
 */
export function DashboardBackground({ className }: { className?: string }) {
  return (
    <div aria-hidden className={cn("fixed inset-0 -z-10 overflow-hidden pointer-events-none", className)}>
      <AuroraBackground className="!absolute !inset-0" />
      <GridPattern size={32} dot={1.2} fade="radial" className="absolute inset-0 opacity-50" />
      <Spotlight size={650} color="rgba(201,169,106,0.18)" />
      <Spotlight size={420} color="rgba(217,119,87,0.10)" />
    </div>
  );
}
